/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { NatsCaller } from "../NatsCaller";
import type {
  AddVoteRequest,
  CreateConfidenceVoteSessionRequest,
  CreateConfidenceVoteSessionResponse,
  EmptyResponse,
  EndConfidenceVoteSessionResponse,
  GetConfidenceVoteSessionsRequest,
  GetConfidenceVoteSessionsResponse,
  GetMyVoteResponse,
  GetParticipantsResponse,
  JoinConfidenceVoteSessionResponse,
  StartConfidenceVoteSessionResponse,
  UpdateConfidenceVoteSessionRequest,
  UpdateConfidenceVoteSessionResponse,
} from "./models";
import {
  createConfidenceVoteSessionResponseSchema,
  emptyResponseSchema,
  endConfidenceVoteSessionResponseSchema,
  getConfidenceVoteSessionsResponseSchema,
  getMyVoteResponseSchema,
  getParticipantsResponseSchema,
  joinConfidenceVoteSessionResponseSchema,
  startConfidenceVoteSessionResponseSchema,
  updateConfidenceVoteSessionResponseSchema,
} from "./schemas";

export class NatsConfidenceVoteClient {
  constructor(private caller: NatsCaller) {}

  async createConfidenceVoteSession(
    payload: CreateConfidenceVoteSessionRequest,
  ): Promise<CreateConfidenceVoteSessionResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.create";
    return await this.caller.request(
      subject,
      "createConfidenceVoteSession",
      payload,
      createConfidenceVoteSessionResponseSchema,
    );
  }

  async endConfidenceVoteSession(
    voting_session_id: string,
  ): Promise<EndConfidenceVoteSessionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.end".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(
      subject,
      "endConfidenceVoteSession",
      {},
      endConfidenceVoteSessionResponseSchema,
    );
  }

  async joinConfidenceVoteSession(
    voting_session_id: string,
  ): Promise<JoinConfidenceVoteSessionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.join".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(
      subject,
      "joinConfidenceVoteSession",
      {},
      joinConfidenceVoteSessionResponseSchema,
    );
  }

  async getConfidenceVoteSessionParticipants(
    voting_session_id: string,
  ): Promise<GetParticipantsResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.participants.get".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(
      subject,
      "getConfidenceVoteSessionParticipants",
      {},
      getParticipantsResponseSchema,
    );
  }

  async getConfidenceVoteSessions(
    payload: GetConfidenceVoteSessionsRequest,
  ): Promise<GetConfidenceVoteSessionsResponse> {
    const subject = "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.search";
    return await this.caller.request(
      subject,
      "getConfidenceVoteSessions",
      payload,
      getConfidenceVoteSessionsResponseSchema,
    );
  }

  async addVote(payload: AddVoteRequest, voting_session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.votes.add".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(subject, "addVote", payload, emptyResponseSchema);
  }

  async getMyVote(voting_session_id: string): Promise<GetMyVoteResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.my_vote.get".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(subject, "getMyVote", {}, getMyVoteResponseSchema);
  }

  async deleteConfidenceVoteSession(voting_session_id: string): Promise<EmptyResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.delete".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(
      subject,
      "deleteConfidenceVoteSession",
      {},
      emptyResponseSchema,
    );
  }

  async updateConfidenceVoteSession(
    payload: UpdateConfidenceVoteSessionRequest,
    voting_session_id: string,
  ): Promise<UpdateConfidenceVoteSessionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.update".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(
      subject,
      "updateConfidenceVoteSession",
      payload,
      updateConfidenceVoteSessionResponseSchema,
    );
  }

  async startConfidenceVoteSession(
    voting_session_id: string,
  ): Promise<StartConfidenceVoteSessionResponse> {
    const subject =
      "pip.${company_id}.${user_id}.rpc.confidence_vote.v1.sessions.${voting_session_id}.start".replace(
        "${voting_session_id}",
        voting_session_id,
      );
    return await this.caller.request(
      subject,
      "startConfidenceVoteSession",
      {},
      startConfidenceVoteSessionResponseSchema,
    );
  }
}
